import './PointsManagementPage.scss'

export default function PointsManagementPage() {
    return (
        <div className="points-page">
            <div className="page-header">
                <div>
                    <div className="page-breadcrumb">
                        Hikaya House / <strong>Points management</strong>
                    </div>

                    <h1>Points management</h1>

                    <p>
                        Earning, expiry and outlet-level configuration
                    </p>
                </div>

                <button className="btn-primary">
                    Save changes
                </button>
            </div>

            <div className="points-card">
                <h2>Earning rate</h2>

                <div className="points-form-grid">
                    <div className="form-group">
                        <label>
                            Points per RM spent
                        </label>

                        <div className="input-wrapper">
                            <input
                                type="text"
                                defaultValue="10"
                            />

                            <span>
                                pts / RM 1
                            </span>
                        </div>

                        <small>
                            Customer earns 10 pts per RM1 spent
                        </small>
                    </div>

                    <div className="form-group">
                        <label>
                            Min spend to earn
                        </label>

                        <div className="input-wrapper">
                            <span className="prefix">
                                RM
                            </span>

                            <input
                                type="text"
                                defaultValue="5"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="points-card">
                <h2>Expiry policy</h2>

                <div className="expiry-options">
                    <div className="expiry-option active">
                        <div className="radio active" />

                        <div>
                            <h3>
                                Permanent — no expiry
                            </h3>

                            <p>
                                Points never expire. Best for long-term loyalty.
                            </p>
                        </div>
                    </div>

                    <div className="expiry-option">
                        <div className="radio" />

                        <div>
                            <h3>
                                Expiring points
                            </h3>

                            <p>
                                Points expire after a set period from when earned.
                            </p>
                        </div>
                    </div>

                    <div className="expiry-option">
                        <div className="radio" />

                        <div>
                            <h3>
                                Reset on activity
                            </h3>

                            <p>
                                Balance resets when customer redeems a reward.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}